import { PropsWithChildren, FC } from 'react'
import classnames from 'classnames'
import { Badge } from 'antd'
import { ArrowUpOutlined } from '@ant-design/icons'

import Box from '~/core/Box'
import Link from '~/core/Link'
import { DfmFragmentType } from '~/apps/consumer/components/PartViewerModal/types'
import { DFM_TAG_NAMES } from '~/lib/partsConstants'
import styles from '../../styles.css'
import { TAG_COLOR } from '../../logic'

const MAX_LENGTH = 83

export const DfmFragment: FC<PropsWithChildren<DfmFragmentType>> = props => {
    const onMouseOver = () => {
        props.onHoveredDfmFeedback(props.id)
    }

    const onMouseOut = () => {
        props.onHoveredDfmFeedback()
    }

    const onClick = () => {
        if (!dfmFeedbackMessage) {
            return
        }
        const { feedback, onClickDfmFeedback, shouldExpandCard } = props

        onClickDfmFeedback(feedback)
        shouldExpandCard(feedback.id)
    }

    const { active, hovered, feedback, shouldExpand } = props
    const dfmFeedbackMessage = feedback?.message
    const displayText =
        dfmFeedbackMessage?.length < MAX_LENGTH
            ? dfmFeedbackMessage
            : `${dfmFeedbackMessage.substring(0, MAX_LENGTH)}...`

    const className = classnames({
        [styles.dfmFeedbackBox]: true,
        [styles.active]: active,
        [styles.hovered]: !active && hovered,
    })

    const tagNames: { [key: string]: string } = DFM_TAG_NAMES
    const tagColor: { [key: string]: string } = TAG_COLOR

    return (
        <Box
            direction="col"
            className={className}
            key={feedback.id}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
            onClick={onClick}
            role="button"
        >
            <Box style={{ textTransform: 'capitalize' }}>
                <Badge
                    color={tagColor[feedback.severity]}
                    style={{ fontWeight: 500 }}
                    text={
                        feedback.title ||
                        tagNames[feedback.severity] ||
                        feedback.severity
                    }
                />
            </Box>
            <Box className={styles.dfmFeedbackMessage} flex direction="col">
                {shouldExpand
                    ? feedback.message
                    : displayText || feedback?.title}
                {shouldExpand && feedback.link && (
                    <Box marginTop="14px">
                        <Link
                            target="_blank"
                            rel="noopener noreferrer"
                            href={feedback.link}
                            placement="dfm-feedback-card"
                            data-test-target="dfm-feedback-learn-more-link"
                        >
                            Learn More <ArrowUpOutlined rotate={45} />
                        </Link>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

export default DfmFragment
